// Power BI dashboard catalogue, grouped by persona.
// URLs mirror the `Persona` menu in Sidebar.js — keep the two in sync when a
// report is added, removed, or re-published.

const PBI = 'https://app.powerbi.com/reportEmbed?reportId=';
const TENANT = '&autoAuth=true&ctid=8a50a18b-c135-4d02-b21a-bd6b114c6755';

const embed = (reportId) => `${PBI}${reportId}${TENANT}`;

const dashboardGroups = [
  {
    persona: 'CEO',
    description: 'Executive view of customers, accounts, and pipeline',
    dashboards: [
      {
        name: 'Customer Management',
        cardIcon: 'flat-color-icons:customer-support',
        description: 'Customer portfolio health, coverage, and engagement overview',
        url: embed('5aa26da8-7573-46c0-9cab-c54a2e9a2459'),
      },
      {
        name: 'Customer 360',
        cardIcon: 'flat-color-icons:contacts',
        description: 'Single consolidated view of every customer relationship',
        url: embed('8dc7df37-876f-4c95-998f-3e5fa0ca81d5'),
      },
      {
        name: 'Opportunity 360',
        cardIcon: 'flat-color-icons:combo-chart',
        description: 'Pipeline, stage movement, and win-rate analytics',
        url: embed('c4f1009c-dcba-45dd-893b-c687194ed1ee'),
      },
      {
        name: 'Accounts 360',
        cardIcon: 'flat-color-icons:database',
        description: 'Account-level revenue, activity, and relationship depth',
        url: embed('70b4c5ad-6ed6-427f-9a6a-e0ba23d12643'),
      },
    ],
  },
  {
    persona: 'CHRO',
    description: 'Workforce, timesheet, and talent analytics',
    dashboards: [
      {
        name: 'Company Overview',
        cardIcon: 'flat-color-icons:statistics',
        description: 'Headcount, utilisation, and organisation-wide HR metrics',
        url: embed('1dcae81a-651d-4752-9f38-ca6d20c468b7'),
      },
      {
        name: 'Daily TimeSheet',
        cardIcon: 'flat-color-icons:alarm-clock',
        description: 'Day-wise timesheet submissions and compliance tracking',
        url: embed('71b441f3-bcc5-4738-bcfc-2e39d45e3d8c'),
      },
      {
        name: 'RMO',
        cardIcon: 'flat-color-icons:mind-map',
        description: 'Resource management — allocation, bench, and demand',
        url: embed('73d0390c-b991-4828-a3d2-2f13794c4cc7'),
      },
      {
        name: 'Timeoff',
        cardIcon: 'flat-color-icons:timeline',
        description: 'Leave balances, absence trends, and approval status',
        url: embed('b89c78b8-814c-4989-8552-9226885ced3d'),
      },
      {
        name: 'Recruiter',
        cardIcon: 'flat-color-icons:contacts',
        description: 'Requisition pipeline, sourcing funnel, and time-to-hire',
        url: embed('6030c96b-b7db-4b51-8d65-75a719f8704e'),
      },
      {
        name: 'PMGM',
        cardIcon: 'flat-color-icons:diploma-1',
        description: 'Performance and goal management across the organisation',
        url: embed('830b9daf-9dd5-4068-bf12-364708eab3fc'),
      },
      {
        name: 'PMO',
        cardIcon: 'flat-color-icons:workflow',
        description: 'Project delivery status, milestones, and effort tracking',
        url: embed('d925f74c-e61f-42fd-b59b-20dab8fa6a90'),
      },
    ],
  },
  {
    persona: 'CFO',
    description: 'Receivables, payables, master data, and revenue planning',
    dashboards: [
      {
        name: 'Customer Aging',
        cardIcon: 'flat-color-icons:currency-exchange',
        description: 'Receivables ageing buckets and collection exposure',
        url: embed('7d92eb38-c318-41ee-92ef-ba7b2d998a4e'),
      },
      {
        name: 'Vendor Aging',
        cardIcon: 'flat-color-icons:money-transfer',
        description: 'Payables ageing, due dates, and vendor outstanding',
        url: embed('9944b5d2-e9a5-42d8-a4db-7eb07f885863'),
      },
      {
        name: 'Customer Aging Details',
        cardIcon: 'flat-color-icons:reading',
        description: 'Invoice-level drill-down behind customer ageing balances',
        url: embed('437b37d3-a67f-4a6e-8804-5cafc7ed16da'),
      },
      {
        name: 'Sales',
        cardIcon: 'flat-color-icons:statistics',
        description: 'Booked revenue, billing trends, and sales performance',
        url: embed('63136864-ec70-4d7e-bd7e-6868884a9830'),
      },
      {
        name: 'Customer Master Data',
        cardIcon: 'flat-color-icons:database',
        description: 'Customer master completeness and data quality checks',
        url: embed('91903dd4-1d7b-441a-9d90-83913e541519'),
      },
      {
        name: 'Vendor Master Data',
        cardIcon: 'flat-color-icons:database',
        description: 'Vendor master completeness and data quality checks',
        url: embed('ede758b7-7d1b-466e-9920-df010321f81d'),
      },
      {
        name: 'Revenue Rolling Plan',
        cardIcon: 'flat-color-icons:paid',
        description: 'Rolling revenue forecast against plan and commitments',
        // Publish-to-web link — loads without a Power BI sign-in.
        url: 'https://app.powerbi.com/view?r=eyJrIjoiNjk4YjBmN2QtNzcyMC00OGI3LWIwNDAtODExZThiMjJiNmQ4IiwidCI6IjhhNTBhMThiLWMxMzUtNGQwMi1iMjFhLWJkNmIxMTRjNjc1NSJ9',
      },
    ],
  },
  {
    persona: 'CSO',
    description: 'Sales leadership view of customers and opportunities',
    dashboards: [
      {
        name: 'Customer Management',
        cardIcon: 'flat-color-icons:customer-support',
        description: 'Customer portfolio health, coverage, and engagement overview',
        url: embed('5aa26da8-7573-46c0-9cab-c54a2e9a2459'),
      },
      {
        name: 'Opportunity 360',
        cardIcon: 'flat-color-icons:combo-chart',
        description: 'Pipeline, stage movement, and win-rate analytics',
        url: embed('c4f1009c-dcba-45dd-893b-c687194ed1ee'),
      },
      {
        name: 'Accounts 360',
        cardIcon: 'flat-color-icons:database',
        description: 'Account-level revenue, activity, and relationship depth',
        url: embed('70b4c5ad-6ed6-427f-9a6a-e0ba23d12643'),
      },
    ],
  },
  {
    persona: 'CDO',
    description: 'Enterprise data and analytics overview',
    dashboards: [
      {
        name: 'Analytics Dashboard',
        cardIcon: 'flat-color-icons:heat-map',
        description: 'Cross-functional data and analytics overview',
        url: embed('2581ab73-2284-443f-b815-93fe6e6aa525'),
      },
    ],
  },
  {
    persona: 'CMO',
    description: 'Marketing view of customers and demand generation',
    dashboards: [
      {
        name: 'Customer Management',
        cardIcon: 'flat-color-icons:customer-support',
        description: 'Customer portfolio health, coverage, and engagement overview',
        url: embed('5aa26da8-7573-46c0-9cab-c54a2e9a2459'),
      },
      {
        name: 'Opportunity 360',
        cardIcon: 'flat-color-icons:combo-chart',
        description: 'Pipeline, stage movement, and win-rate analytics',
        url: embed('c4f1009c-dcba-45dd-893b-c687194ed1ee'),
      },
      {
        name: 'Accounts 360',
        cardIcon: 'flat-color-icons:database',
        description: 'Account-level revenue, activity, and relationship depth',
        url: embed('70b4c5ad-6ed6-427f-9a6a-e0ba23d12643'),
      },
    ],
  },
];

export default dashboardGroups;
